export default "__VITE_ASSET__4809d191__"